export default [
  {
    path: '/team',
    name: 'team',
    meta: { title: '我的团队', auth: true, color: '#FD6404', keepAlive: true, deepth: 1 },
    component: () => import('../../views/team')
  },
  {
    path: '/employee-detail',
    name: 'employee-detail',
    meta: { title: '员工详情', auth: true, color: '#FD6404', deepth: 2 },
    component: () => import('../../views/team/employee/employee-detail')
  },
  {
    path: '/leader-invite',
    name: 'leader-invite',
    meta: { title: '邀请海报', auth: true, deepth: 2 },
    component: () => import('../../views/team/leader/leader-invite')
  }
];
